import React, { Component } from 'react'
import SystemRegistry from './systemRegistry'
import { Toast, ToastContainer } from 'react-bootstrap'
import Event from './eventSystem/Event'

export default class ToastHandler extends Component {

    constructor(props) {
        super(props)
        this.state = { "toasts": [] }
        this.styleCheat = {}
        this.styleCheat[Event.INFO] = "light"
        this.styleCheat[Event.ERROR] = "light "
    }

    componentDidMount() {
        SystemRegistry.gI().registerToastContainer(this)
    }

    addToast(toast) {
        this.setState({ "toasts": this.state.toasts.concat(toast) })
        return toast.id
    }
    removeToast(toastID) {
        var newToasts = []
        for (let i = 0; i < this.state.toasts.length; i++) {
            const element = this.state.toasts[i];
            if (element.id === toastID) {
                continue
            }
            newToasts.push(element)
        }
        this.setState({ "toasts": newToasts })
    }

    render() {
        //console.log(`Rerender with ${this.state.toasts.length} toasts`)
        return (
            <div
                aria-live="polite"
                aria-atomic="true"
                className=" position-absolute"
                style={{ height: "100vh", width: "100vw", "pointer-events": "none" }}
            >
                <ToastContainer position="top-center" className="p-3">
                    {this.state.toasts.map(toast => {
                        return <Toast key={toast.id} onClose={() => this.removeToast(toast.id)} delay={5000} autohide={true}>
                            <Toast.Header closeButton={false}>
                                <strong className="me-auto">{toast.headerMessage}</strong>
                            </Toast.Header>
                            <Toast.Body>{toast.message}</Toast.Body>
                        </Toast>

                    })}
                </ToastContainer>
            </div>
        );

    }
}


export class ToastData {

    constructor(type, headerMessage, message) {
        this.type = type
        this.headerMessage = headerMessage
        this.message = message
        this.id = crypto.randomUUID()
    }
}